/* eslint-disable react/prop-types */
import Modal from '../../common/Modal';
import styled from 'styled-components';
import CustomButton from '../../common/Button';

interface ApproveFacilityModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ApproveFacilityModal: React.FC<ApproveFacilityModalProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  const handleApprove = () => {
    try {
      onConfirm();
      onCancel();
    } catch (error) {
      console.log('Error approving facility:', error);
    }
  };

  return (
    <Modal
      title="Approve Facility"
      open={open}
      onCancel={onCancel}
      minHeight="auto"
      removeFooterMargin={true}
    >
      <StyledText>
        Please confirm if you’d like to approve the booking facility for end
        users.
      </StyledText>
      <ButtonSection>
        <CustomButton onClick={onCancel}>Cancel</CustomButton>
        <CustomButton type="primary" onClick={handleApprove}>
          Approve
        </CustomButton>
      </ButtonSection>
    </Modal>
  );
};

const StyledText = styled.p`
  width: 100%;
  white-space: nowrap;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
`;

export default ApproveFacilityModal;
